// Centralised brand constants for ooloo
export const BRAND = {
  name: "ooloo",
  tagline: "your daily kitchen partner",
  slogan: "Good food. Happy home. That's ooloo.",
  city: "Lucknow",
  zones: ["Gomti Nagar", "Gomti Nagar Extension", "Sushant Golf City"],
  whatsappNumberRaw: "7318086600",
  whatsappCountry: "91",
  email: "info@oolookitchen.in",
  phoneDisplay: "+91 73180 86600",
  promise: "On-demand kitchen support at your doorstep in 30 minutes",
  exclusions: ["No kitchen cleaning", "No utensil cleaning", "No serving"],
  siteUrl:
    process.env.REACT_APP_SITE_URL ||
    (typeof window !== "undefined" ? window.location.origin : ""),
  instagramHandle: "oolookitchen",
  instagramUrl: "https://instagram.com/oolookitchen",
  facebookUrl: "https://facebook.com/oolookitchen",
};

export const WHATSAPP_LINK = `https://wa.me/${BRAND.whatsappCountry}${BRAND.whatsappNumberRaw}`;

export const waLink = (message) => {
  const base = WHATSAPP_LINK;
  if (!message) return base;
  return `${base}?text=${encodeURIComponent(message)}`;
};
